import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from 'partnerhub';
import { Observable } from 'rxjs';
import { filter, map, pluck, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Product } from '../../models';
import { Package } from '../../models/package/package.model';

@Injectable({
  providedIn: 'root',
})
export class PackageService {

  public baseURL = environment.serverApiBaseUrl;
  constructor(private readonly http: HttpClient, private readonly helperService: HelperService) {}

  public getOfferDetails(offerId: number): Observable<any> {
    const url = `/api/webapp-mep-maxis-admin/products/${offerId}`;

    return this.http.get<any>(url).pipe(pluck('responseData'));
  }

  public getOffersByProduct(productId: number): Observable<any> {
    // TODO: Waiting for BE to migrate endpoint
    const url = `/api/webapp-mep-maxis-admin/products/productDefs/${productId}/products`;

    return this.http.get<any>(url).pipe(pluck('responseData'));
  }

  public getPackageById(packageId): any {
    const url = `/${this.baseURL}/package/${packageId}`;
    return this.http.get(url);
  }

  public getPackageLoyaltyById(packageId): any {
    const url = `/${this.baseURL}/package/${packageId}/loyalty`;
    return this.http.get(url);
  }

  public tableSortOrderLogic(sortOrder) {
    return sortOrder === 1 ? (sortOrder = true) : (sortOrder = false);
  }

  public tableSortLogic(sort) {
    return (sort = sort ? '&sort=' + sort : '');
  }

  public tableGlobalFilterLogic(globalFilter) {
    return (globalFilter = globalFilter ? '&globalFilter=' + globalFilter : '');
  }

  public tableFilterLogic(myFilters) {
    if (myFilters) {
      let filters = '';
      let filterFields = Object.keys(myFilters);
      filterFields.map((filterField, i) => {
        const filterValue = myFilters[filterField]?.value
          ? myFilters[filterField].value
          : typeof myFilters[filterField] == 'string'
          ? myFilters[filterField]
          : '';

        if (filterField != 'global' && filterValue) {
          if (i == 0) {
            filters = '&' + filters + filterField + '=' + filterValue;
          } else {
            filters = filters + '&' + filterField + '=' + filterValue;
          }
        }
      });
      return (myFilters = filters);
    } else {
      return (myFilters = '');
    }
  }

  public getPackageCount = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/package/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  };

  public getPackages = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Package[]> => {
    const url =
      `/${this.baseURL}/package?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Package[]>(url);
  };

  public getNumberPackageOffersByPackageId = (
    packageId: number = 0,
    globalFilter?: any,
    myFilters?: any
  ): Observable<number> => {
    const url =
      `/${this.baseURL}/package/${packageId}/offers/count?&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getPackageOffersByPackageId = (
    packageId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Product[]> => {
    const url = `/${this.baseURL}/package/${packageId}/offers?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url);
  }

  public getNumberProductsCoexByPackageId = (
    packageId: number = 0,
    globalFilter?: any,
    myFilters?: any
  ): Observable<number> => {
    const url =
      `/${this.baseURL}/package/${packageId}/exclusionOffers/count?&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getProductsCoexByPackageId = (
    packageId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Product[]> => {
    const url =
      `/${this.baseURL
      }/package/${packageId}/exclusionOffers?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url).pipe(map((data: Product[]) =>{
      data.map(product => {
        if(!product.idVivo){
          product.idVivo = product['productIdVivo']
          product.name = product['productName']
        }
        if(!product.productType && product['type'])
            product.productType = product['type']
      })
      return data
    }));
  }

  public getNumberProductsByPackageId = (
    packageId: number = 0,
    globalFilter?: any,
    myFilters?: any
  ): Observable<number> => {
    const url =
      `/${this.baseURL}/package/${packageId}/products/count?&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getProductsByPackageId = (
    packageId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Product[]> => {
    const url =
      `/${this.baseURL
      }/package/${packageId}/products?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url).pipe(map((data: Product[]) =>{
      data.map(product => {
        if(!product.idVivo){
          product.idVivo = product['productIdVivo']
          product.name = product['productName']
        }
        if(!product.productType && product['type'])
          product.productType = product['type']
      })
      return data
    }));
  }

  public getInactiveProductsByPackageId = (
    packageId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Product[]> => {
    const url =
      `/${this.baseURL
      }/package/${packageId}/inactive-products?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url).pipe(map((data: Product[]) =>{
      data.map(product => {
        if(!product.idVivo){
          product.idVivo = product['productIdVivo']
          product.name = product['productName']
        }
        if(!product.productType && product['type'])
            product.productType = product['type']
      })
      return data
    }));
  }

  public getNumberInactiveProductsByPackageId = (
    packageId: number = 0,
    globalFilter?: any,
    myFilters?: any
  ): Observable<number> => {
    const url =
      `/${this.baseURL}/package/${packageId}/inactive-products/count?&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url)
  }

  public buildArrayElegibility(formValues): any[] {
    if(!formValues){
      return formValues;
    }
    let chargingCodes = formValues.map(data => {
      return {
        eligibilityName: data.id.split("|")[0],
        paymentTypeIds: data.id.split("|")[1],
      }
    });

    chargingCodes = this.groupByEligibility(chargingCodes);

    console.log("DEBUG (saveElegibility):", formValues, chargingCodes);

    return chargingCodes;
  }

  private groupByEligibility(arr) {
    return Object.values(
      arr.reduce((acc, { eligibilityName, paymentTypeIds }) => {
        if (!acc[eligibilityName]) {
          acc[eligibilityName] = {
            eligibilityName,
            paymentTypeIds: []
          };
        }
        acc[eligibilityName].paymentTypeIds.push(paymentTypeIds);
        return acc;
      }, {})
    );
  }

  public createPackageConstituents(formValues, packageId){

    const url = `/${this.baseURL}/package/create/products`;
    
    let form = {
      ...formValues.formData, 
      ...formValues.formDataNotificationPartner, 
      ...formValues.formDataOffer, 
      ...formValues.formDataOfferCommunication, 
      ...formValues.formDataOfferPriceModel
    }
    form.bundleId = packageId;
    form.isFixedLine = formValues.formDataOffer.isFixedLine == "yes" ? true : false;
    form.isExtensionNotify = form.extensionNotify?.id;
    form.partnerId = form.partnerId?.id;
    form.chargingType = form.chargingType?.id;
    form.companyOwner = form.companyOwner?.id; 
    form.offerStatus = form.offerStatus?.id; 
    form.offerType = form.offerType?.id;
    form.period = form.period?.id;
    form.renewPriority = form.renewPriority?.id;
    form.CTRaccount = form.CTRaccount?.id;
    form.controlMode = form.isFixedLine && form.controlMode ? form.controlMode.id.toUpperCase() : '';
    form.chargeDescription = form.offerType === 'avulso' ? form.chargeDescriptionOneShot : form.chargeDescription;
    delete form.chargeDescriptionOneShot;
    form.landLineService = form.isFixedLine;
    const usedElegibility = form.isFixedLine ? form.eligibilityLandline : form.eligibility;
    if(form.isFixedLine){
      const landlineChargeCodes = {};
      formValues.formDataOffer.eligibilityLandline.forEach(data => {
        const userPlan = data.id.split("|")[0];
        const chargingCode = formValues.formDataOffer[data.id];
        if(chargingCode){
          landlineChargeCodes[userPlan] = { userPlan, chargingCode };
        }
      });
      form.chargingCodes = { chargeCodes: Object.values(landlineChargeCodes) };
    } else {
      if(formValues.formDataOffer.eligibility?.length > 0){
        form.chargingCodes = {
          chargeCodes: formValues.formDataOffer.eligibility.map(data => {
            const eligibilityName = data.id.split("|")[0];
            const paymentTypeId = data.id.split("|")[1];
            const isCreditCard = formValues.creditCardPaymentTypeId && paymentTypeId === formValues.creditCardPaymentTypeId;
            return {
              userPlan: eligibilityName,
              chargingCode: isCreditCard ? formValues.formDataOffer.chargingCodeCreditCard : formValues.formDataOffer.chargingCode
            }
          })
        };
      } else {
        form.chargingCodes = { chargeCodes: [] };
      }
    }

    form.howToUse = form.howToUseStep.map(data => data.howToUseStepItem); 
    form.eligibility = this.buildArrayElegibility(usedElegibility);
    Object.keys(form).forEach(key => {
      if(key.includes('|')){
        delete form[key];
      }
    });
    delete form.eligibilityLandline;
    delete form.eligibilityPreBundle;
    const getFormValue = (field: any): any => {
      if (field && typeof field === 'object') {
        if ('value' in field) return field.value;
        if ('id' in field) return field.id;
      }
      return field;
    };
    form.tributes = {
      cClassCode: formValues.formDataOffer.cClassCode,
      billingCompany: form.companyOwner,
      issTaxRate: getFormValue(formValues.formDataOffer.issTaxRate),
      pisTaxRate: getFormValue(formValues.formDataOffer.pisTaxRate),
      cofinsTaxRate: getFormValue(formValues.formDataOffer.cofinsTaxRate),
      icmsTaxRate: getFormValue(formValues.formDataOffer.icmsTaxRate)
    }

    return this.http.post<any>(url, form)
    .pipe(
      tap({
        next: x => { console.log(x); },
        error: err => { console.error(err); },
      })
    );
  }

  public createPackageCoexistence(formValues, packageId){
    const url = `/${this.baseURL}/package/create/exclusionOffers`;
    let body = {packageId: packageId, offersId: []};
    formValues.map(form => {
      body.offersId.push(form.offerId);
    });
    return this.http.post(url, body);
  }

  public getNonCoexByPackageId = (
    packageId: number,
    productId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Product[]> => {
    const url =
      `/${this.baseURL}/package/${packageId}/products/${productId}/exclusionOffers?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url);
  }

  public getNonCoexByPackageIdCount = (packageId: number, productId: number, globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/package/${packageId}/products/${productId}/exclusionOffers/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public createNonCoexistence(packageId, productId, formValues){
    console.log("DEBUG package:",packageId, productId, formValues);
    const url = `/${this.baseURL}/package/${packageId}/products/${productId}/exclusionOffers/create`;
    return this.http.post(url, formValues);
  }

  public deleteNonCoexistence(packageId, productId, coexId){
    let data = {offersId: [coexId]};
    const url = `/${this.baseURL}/package/${packageId}/products/${productId}/exclusionOffers/delete`;
    return this.http.post(url, data);
  }

  public getPackagesByPriority(packageId = 0, priority: number) {
    const url = `/${this.baseURL}/package/${packageId}/getPackagesByPriority/${priority}`;
    return this.http.get(url);
  }

  public getSKUs = (
    offerId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any[]> => {
    const url =
      `/${this.baseURL
      }/product/${offerId}/sku/?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<any[]>(url).pipe(map((data: any[]) =>{
      return data
    }));
  }

  public getSKUsCount = (
    offerId: number = 0
  ): Observable<any[]> => {
    const url =
      `/${this.baseURL
      }/product/${offerId}/sku/count`;
    return this.http.get<any[]>(url).pipe(map((data: any[]) =>{
      return data
    }));
  }

  public createSku(formValues, constituentId, packageId, bundleId){
    const url = `/${this.baseURL}/product/addBundleSku?bundleId=${bundleId}&constituentId=${constituentId}`;
    let body = [formValues];
    return this.http.put(url, body);
  }

  public removeSku(formValues, bundleId, constituentId){
    const url = `/${this.baseURL}/product/removeBundleSku?bundleId=${bundleId}&constituentId=${constituentId}`;
    let body = [formValues];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: body
    };
    return this.http.delete(url, options);
  }

  public getSKUsOffer = (
    offerId: number = 0,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any[]> => {
    const url =
      `/${this.baseURL
      }/offer/${offerId}/sku/?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<any[]>(url).pipe(map((data: any[]) =>{
      return data
    }));
  }

  public getSKUsCountOffer = (
    offerId: number = 0
  ): Observable<any[]> => {
    const url =
      `/${this.baseURL
      }/offer/${offerId}/sku/count`;
    return this.http.get<any[]>(url).pipe(map((data: any[]) =>{
      return data
    }));
  }

  public createSkuOffer(formValues, productId, offerId){
    const url = `/${this.baseURL}/offer/${offerId}/addSku?productId=${productId}`;
    let body = [formValues];
    return this.http.put(url, body);
  }

  public removeSkuOffer(formValues, offerId){
    const url = `/${this.baseURL}/offer/${offerId}/removeSku`;
    let body = [formValues];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: body
    };
    return this.http.delete(url, options);
  }
}
